import {
  ActivityChangeOptions,
  DeltaText,
} from '@spotify/plugin-confidence-activity-react';
import { createWorkflowUpdatesChangeExtension } from '@spotify/plugin-confidence-workflows-react';

interface PlanningData {
  startDate?: string;
  endDate?: string;
  [key: string]: unknown;
}

const PlanningChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as PlanningData | null;
  const newValue = change.newValue as PlanningData | null;

  const oldStartDate = oldValue?.startDate ?? '';
  const newStartDate = newValue?.startDate ?? '';
  const oldEndDate = oldValue?.endDate ?? '';
  const newEndDate = newValue?.endDate ?? '';

  if (oldStartDate !== newStartDate || oldEndDate !== newEndDate) {
    const oldText =
      oldStartDate || oldEndDate
        ? `${oldStartDate || 'Not set'} - ${oldEndDate || 'Not set'}`
        : '';
    const newText = `${newStartDate || 'Not set'} - ${newEndDate || 'Not set'}`;

    return <DeltaText oldText={oldText} newText={newText} disableDiff />;
  }

  return <DeltaText oldText="" newText="Updated" disableDiff />;
};

export const PLANNING_CHANGE_EXTENSION = createWorkflowUpdatesChangeExtension({
  id: 'planning-change',
  predicate: ({ change }) => change.fieldPath === '/module_data/planning',
  title: change => {
    const oldValue = change.oldValue as PlanningData | null;
    const newValue = change.newValue as PlanningData | null;

    const hadDates = oldValue?.startDate || oldValue?.endDate;
    const hasDates = newValue?.startDate || newValue?.endDate;

    if (!hadDates && hasDates) {
      return 'Set planned dates';
    }

    return 'Updated timeline';
  },
  render: PlanningChangeRender,
});
